<template>
    <div class="cancellation-policy"
        v-if="show">
        <p>{{ localizedText }}</p>
    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'cancellationpolicy',
    	props: {
    		policy: Object,
    		translation: {
    			type: String,
    			default: 'Bis __DAYS__ Tage vor Anreise kostenlos stornierbar.'
    		}
    	},
    	data: function() {
    		return {
    			show: false
    		};
    	},
    	computed: {

    		maxDaysBeforeArrival() {
    				if (!this.policy || !this.policy.byDaysTillArrival) return null;
    				return Math.max(...this.policy.byDaysTillArrival.map(p => p.daysBeforeArrival));
    			},
    			localizedText() {
    				return this.translation.replace('__DAYS__', this.maxDaysBeforeArrival);
    			}

    	},
    	mounted: function() {

    		if (this.policy && this.policy.byDaysTillArrival && !this.policy.defaultPenalty) {
    			console.log('this.policy.defaultPenalty', this.policy.defaultPenalty);
    			this.show = true;
    		}

    	},

    };
</script>